import axios from "../axios"

const userApi = {
	login({
		loginName,
		password
	}) {
		return axios({
			url: `/gzeua/Login/Login`,
			method: "post",
			data: {
				loginName,
				password,
			}
		})
	},
	
	queryRole(data) {
		return axios({//查询角色列表
			url: `/gzeua/Role/Search`,
			method: "post",
			data
		})
	},
	searchUserByName(data) {
		return axios({//查询角色列表
			url: `/gzeua/user/queryUserInfo`,
			method: "post",
			data
		})
	},
	addRole(data) {
		return axios({//修改角色
			url: `/gzeua/Role/CreateOrEdit`,
			method: "post",
			data
		})
	},
	
	deleteRole(id) { //删除角色
		return axios({
			url: `/gzeua/Role/Delete`,
			method: "post",
			params:{id}
		})
	},
	
	queryUserRole(userId) { //查询用户角色
		return axios({
			url: `/gzeua/UserRole/GetByUserRole`,
			method: "post",
			params:{userId}
		})
	},
	
	queryRoleUser(data) { //查询角色用户
		return axios({
			url: `/gzeua/User/QueryUserWithRole`,
			method: "post",
			data
		})
	},
	
	setUserRole(data) { //修改用户角色
		return axios({
			url: `/gzeua/TUserRole/setUserRole`,
			method: "post",
			data
		})
	},
	
	deleteUserRole(id) { //删除用户角色
		return axios({
			url: `/gzeua/TUserRole/Delete`,
			method: "post",
			params:{id}
		})
	},
	
	changePwd(data) { //修改密码
		return axios({
			url: `/gzeua/User/editpassword`,
			method: "post",
			data
		})
	},
	resetPwd(userId) { //重置密码 
		return axios({
			url: `/gzeua/Account/ReSetPassWord`,
			method: "post",
			params:{userId}
		})
	},
	
	changeUserName(oldLoginName,newLoginName) { //修改用户名
		return axios({
			url: `/gzeua/Account/ReEditLoginName`,
			method: "post",
			params:{oldLoginName,newLoginName}
		})
	},
	
	queryUser(data) { //查询用户列表
		return axios({
			url: `/gzeua/Account/Query`,
			method: "post",
			data
		})
	},
	
	queryUserRoleSelf() { //查询用户自己角色
		return axios({
			url: `/gzeua/UserRole/QueryCurrentUser`,
			method: "post",
		})
	},
	queryUserInfo(data) { //查询用户信息列表
		return axios({
			url: `/gzeua/Account/UserInfoSearch`,
			method: "post",
			data
		})
	},
	editUserInfo(data) { //修改用户信息列表
		return axios({
			url: `/gzeua/Account/UpdateUserInfo`,
			method: "post",
			data
		})
	},
	editUserStatus(userid,sta) { //修改用户信息列表
		return axios({
			url: `/gzeua/Account/UserStatusSave`,
			method: "post",
			params:{userid,sta}
		})
	},
	
	getPwdVertifyLists(data) { //查询密码申诉
		return axios({
			url: `/gzeua/UserFindBack/Query`,
			method: "post",
			data
		})
	},
	
	checkDefined(id,status) { //保存申诉审核
		return axios({
			url: `/gzeua/UserFindBack/UpdateHJUserFindBack`,
			method: "post",
			params:{id,status}
		})
	},
	getRetrievePass(data) {
		return axios({
		  url: `/gzeua/Login/ReFindPassWord`,
		  method: "post",
		  data,
		});
	  },
	SaveHJUserFindBack(data) {
		return axios({
		  url: `https://jk.hj.hjxy.org.cn/api/UserFindBack/SaveHJUserFindBack`,
		  method: "post",
		  data,
		});
	  },
	  findBackUploadFile(data) {
		return axios({
		  url: `https://jk.hj.hjxy.org.cn/file?path=${data.path}&secondPath=${data.secondPath}&fileName=${data.fileName}`,
		  method: "post",
		  data: data.file,
		});
	  },
	
	regisComs(data) { //企业注册
		return axios({
			url: `/gzeua/Login/regist`,
			method: "post",
			data
		})
	},
		//获取用户地区列表
		getUserRegionList() {
			return axios({
				url: "gzeua/User/GetUserRegionId",
				method: "post",
			})
		},
		ImExportCompanyAndAppraise({
			formData,
			file,
		  }) {
			//secondPath  uappcomid/seqnum
			return axios({
				url: `/gzeua/ImExportCompanyAndAppraise/ImExport`,
				method: "post",
				data:formData,
				file,
				headers: {
				  "Content-Type": "multipart/form-data",
				},
				processData: false,
			})
		},
	
}
export default userApi
